import { Shield, Star, Award, Clock } from "lucide-react";

const signals = [
  { icon: Shield, label: "Licensed in 6 States", sub: "AZ • TX • NC • IL • AR • CA" },
  { icon: Star, label: "30+ Insurance Carriers", sub: "Compare & save on coverage" },
  { icon: Award, label: "5-Star Rated", sub: "Trusted by AZ families" },
  { icon: Clock, label: "Same-Day Quotes", sub: "Get rates in minutes" },
];

const TrustSignals = () => {
  return (
    <section className="py-12 md:py-16 bg-surface-alt">
      <div className="container">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {signals.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.label} className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
                  <Icon className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground">{s.label}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{s.sub}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;
